import { render, staticRenderFns } from "./DeerDisease.vue?vue&type=template&id=0c4e4640&"
import script from "./DeerDisease.vue?vue&type=script&lang=js&"
export * from "./DeerDisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports